import{createContext}from"react";export const KibApplicationContext=createContext({portalIds:{},overlayOpen:!1,setOverlayOpen:()=>{}});